import AsideEditor from '@UI/editor/AsideEditor';
import type { EditAsideTitle } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideTitle: React.FC<{
  config: EditAsideTitle;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  return (
    <div>
      <label className="control-label">{config.label}</label>
      <div className="form-control">
        <AsideEditor
          field={config.property}
          initial={initialValue}
          skey={getResourceKey(editHref)}
          readOnly={readonly}
          inline
          placeholder={`Vul een ${config.label.toLowerCase()} in...`}
        />
      </div>
    </div>
  );
};

AsideTitle.displayName = 'AsideTitle';

export default AsideTitle;

AsideTitle.propTypes = {
  config: any,
  readonly: any,
};
